(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nco-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-hero-banner')) {
    customElements.define('premium-hero-banner', class extends HTMLElement {
      connectedCallback() {
        // Le composant se reconnecte également lors de shopify:section:load.
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.controller?.abort();
      }

      initialize() {
        this.controller?.abort();
        clearTimeout(this.timer);

        const root = document.getElementById(this.dataset.section);
        if (!root || !this.isConnected) return;

        const scope = '#' + CSS.escape(root.id) + ' ';
        const all = selector => Array.from(root.querySelectorAll(scope + selector));
        const one = selector => root.querySelector(scope + selector);

        this.slides = all('.hp-slide');

        // Aucun carousel ni écouteur supplémentaire pour une seule slide.
        if (this.slides.length < 2) return;

        this.controller = new AbortController();

        const on = (target, event, handler, options = {}) => {
          target?.addEventListener(event, handler, {
            ...options,
            signal: this.controller.signal
          });
        };

        this.track = one('.hp-track');
        this.dots = all('.hp-dot');
        this.status = one('.hp-status');
        this.pauseButton = one('.hp-pause');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');

        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.pointer = null;

        one('.hp-nav').hidden = false;

        on(one('.hp-prev'), 'click', () => this.previousSlide());
        on(one('.hp-next'), 'click', () => this.nextSlide());

        this.dots.forEach(dot => {
          on(dot, 'click', () => this.goToSlide(Number(dot.dataset.index)));
        });

        on(this.pauseButton, 'click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        });

        on(this, 'mouseenter', () => {
          this.hovered = true;
          this.schedule();
        });

        on(this, 'mouseleave', () => {
          this.hovered = false;
          this.schedule();
        });

        on(this, 'focusin', () => {
          this.focused = true;
          this.schedule();
        });

        on(this, 'focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        });

        on(document, 'visibilitychange', () => this.schedule());

        on(this.motion, 'change', () => {
          this.updatePause();
          this.schedule();
        });

        on(this, 'keydown', event => {
          if (
            event.altKey ||
            event.ctrlKey ||
            event.metaKey ||
            /INPUT|TEXTAREA|SELECT/.test(event.target.tagName) ||
            event.target.isContentEditable
          ) return;

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.nextSlide();
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.previousSlide();
          }

          if (event.key === 'Home') {
            event.preventDefault();
            this.goToSlide(0);
          }

          if (event.key === 'End') {
            event.preventDefault();
            this.goToSlide(this.slides.length - 1);
          }
        });

        on(this, 'touchstart', event => {
          if (event.touches.length !== 1) {
            this.pointer = null;
            return;
          }

          const touch = event.touches[0];
          this.pointer = { x: touch.clientX, y: touch.clientY };
          clearTimeout(this.timer);
        }, { passive: true });

        on(this, 'touchend', event => {
          if (!this.pointer) return;

          const touch = event.changedTouches[0];
          const dx = touch.clientX - this.pointer.x;
          const dy = touch.clientY - this.pointer.y;

          this.pointer = null;

          if (
            Math.abs(dx) > 50 &&
            Math.abs(dx) > Math.abs(dy) * 1.5
          ) {
            this.suppressClick = Date.now() + 400;
            dx < 0 ? this.nextSlide() : this.previousSlide();
          } else {
            this.schedule();
          }
        }, { passive: true });

        on(this, 'touchcancel', () => {
          this.pointer = null;
          this.schedule();
        }, { passive: true });

        on(this, 'click', event => {
          if (Date.now() < (this.suppressClick || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { capture: true });

        on(root, 'shopify:block:select', event => {
          const index = this.slides.findIndex(
            slide => slide.dataset.block === event.detail.blockId
          );

          if (index >= 0) {
            this.editorSelected = true;
            this.goToSlide(index, false);
          }
        });

        on(root, 'shopify:block:deselect', () => {
          this.editorSelected = false;
          this.schedule();
        });

        this.updatePause();
        this.goToSlide(0, false);
      }

      nextSlide() {
        this.goToSlide(this.index + 1);
      }

      previousSlide() {
        this.goToSlide(this.index - 1);
      }

      goToSlide(index, announce = true) {
        const next = (index + this.slides.length) % this.slides.length;
        const old = this.slides[this.index];
        const moveFocus = (
          next !== this.index &&
          old.contains(document.activeElement)
        );

        this.index = next;
        this.track.style.transform = `translate3d(${-next * 100}%, 0, 0)`;

        this.slides.forEach((slide, i) => {
          slide.inert = i !== next;
          slide.setAttribute('aria-hidden', String(i !== next));
        });

        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', String(i === next));
        });

        if (moveFocus) {
          const root = document.getElementById(this.dataset.section);
          const scope = '#' + CSS.escape(root.id);
          const blockId = CSS.escape(this.slides[next].dataset.block);

          root.querySelector(
            `${scope} .hp-slide[data-block="${blockId}"] .hp-content`
          )?.focus({ preventScroll: true });
        }

        if (announce) {
          this.status.textContent = (
            `Diapositive ${next + 1} sur ${this.slides.length}`
          );
        }

        this.schedule();
      }

      updatePause() {
        if (!this.pauseButton) return;

        const stopped = this.paused || this.motion.matches;

        this.pauseButton.disabled = this.motion.matches;
        this.pauseButton.setAttribute('aria-pressed', String(stopped));

        this.pauseButton.setAttribute(
          'aria-label',
          this.motion.matches
            ? 'Défilement désactivé : mouvements réduits'
            : stopped
              ? 'Reprendre le défilement'
              : 'Mettre le défilement en pause'
        );

        this.pauseButton.firstElementChild.textContent = stopped ? '▶' : 'Ⅱ';
      }

      schedule() {
        clearTimeout(this.timer);

        if (
          this.dataset.autoplay !== 'true' ||
          this.paused ||
          this.motion.matches ||
          this.focused ||
          this.editorSelected ||
          document.hidden ||
          this.pointer ||
          (this.hovered && this.dataset.hover === 'true') ||
          window.Shopify?.designMode
        ) return;

        this.timer = setTimeout(
          () => this.goToSlide(this.index + 1, false),
          Number(this.dataset.delay) || 5000
        );
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
